/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Quima_backend
 * OpenAPI spec version: v1
 */
import axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  GetDownloadimageParams,
  GetGetimagebyidParams,
  GetGetimagebyuseridParams,
  GetGetuseridbyfilenameimageParams
} from '../generated.schemas';




  export const getImage = (axiosInstance: AxiosInstance = axios) => {
/**
 * @summary Downloads an image file by filename.
 */
const getDownloadimage = (
    params?: GetDownloadimageParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/downloadimage`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Streams an image file by filename.
 */
const getApiImageStreamFileName = (
    fileName: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Image/stream/${fileName}`,options
    );
  }
/**
 * @summary Deletes an image by its ID.
 */
const deleteDeleteimageImageId = (
    imageId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(
      `/deleteimage/${imageId}`,options
    );
  }
/**
 * @summary Retrieves an image by its ID.
 */
const getGetimagebyid = (
    params?: GetGetimagebyidParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/getimagebyid`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Retrieves all images associated with a specific user ID.
 */
const getGetimagebyuserid = (
    params?: GetGetimagebyuseridParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/getimagebyuserid`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Retrieves all images in the database.
 */
const getGetallimages = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/getallimages`,options
    );
  }
/**
 * @summary Retrieves the user ID associated with a specific filename.
 */
const getGetuseridbyfilenameimage = (
    params?: GetGetuseridbyfilenameimageParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/getuseridbyfilenameimage`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
return {getDownloadimage,getApiImageStreamFileName,deleteDeleteimageImageId,getGetimagebyid,getGetimagebyuserid,getGetallimages,getGetuseridbyfilenameimage}};
export type GetDownloadimageResult = AxiosResponse<void>
export type GetApiImageStreamFileNameResult = AxiosResponse<void>
export type DeleteDeleteimageImageIdResult = AxiosResponse<void>
export type GetGetimagebyidResult = AxiosResponse<void>
export type GetGetimagebyuseridResult = AxiosResponse<void>
export type GetGetallimagesResult = AxiosResponse<void>
export type GetGetuseridbyfilenameimageResult = AxiosResponse<void>
